import React, { useState } from "react";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import { useAuth } from "../../../contexts/AuthContext";
import { useOtp } from "../../../contexts/OtpContext";
import { useDispatch, useSelector } from "react-redux";
import { sendOTPAsync } from "../../../lib/service/otp/sendOTPSlice";
import { verifyOTPAsync } from "../../../lib/service/otp/verifyOTPSlice";
import LoginEmail from "../../../layout/LoginEmail";
import LoginVerify from "../../../layout/LoginVerify";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
function Subscribe({ email, setEmail, error, setError, handleInputChange }) {
  const [showModal, setShowModal] = useState("login");
  const { login, loggedIn } = useAuth();
  const { otp } = useOtp();
  const otpString = Object.values(otp).join("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sendOTPState = useSelector((state) => state.sendOTP);
  const verifyOTPState = useSelector((state) => state.verifyOTP);
  const handleButtonClick = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;

    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
      toast.error("Please enter a valid email address.")

    } else if (email) {
      // Dispatch sendOTPAsync if email is valid
      dispatch(sendOTPAsync({ email }))
        .unwrap()
        .then(() => {
          login();
          navigate("/verification", { state: { status: true } });
          toast.success("Logged Successfully")
        })
        .catch((error) => {
          console.error("Error sending OTP:", error);
          // setError(error?.message);
          navigate("/reservation", { state: { status: "error" } });
        });
    } else {
    }
  };

  return (
    <div className="leap-text-center leap-w-full leap-rounded-md lg:leap-w-[70%] leap-text-white leap-bg-[linear-gradient(90deg,_#411C68_0%,_#273058_100%),_linear-gradient(0deg,_rgba(0,0,0,0.2),_rgba(0,0,0,0.2)),_linear-gradient(0deg,_rgba(0,0,0,0.2),_rgba(0,0,0,0.2)),_linear-gradient(0deg,_rgba(0,0,0,0.2),_rgba(0,0,0,0.2))] leap-z-50 leap-container lg:leap-rounded-[30px] leap-min-h-[180px] 2xl:leap-min-h-[203px]">
      <div
        className={`leap-flex leap-w-[70%] leap-mx-auto leap-flex-col leap-gap-5 leap-justify-center ${error ? "leap-h-[150px] lg:leap-h-[203px]" : "leap-h-[150px] lg:leap-h-[203px]"} `}
      >
        <div>
          {!loggedIn && (
            <span className="leap-text-center leap-text-[12px] md:leap-text-[20px] lg:leap-text-[20px] xl:leap-text-[28px]  2xl:leap-text-[36px]  leap-leading-[33px] leap-font-medium">
              Book Your Tour Now
            </span>
          )}
          {loggedIn && (
            <span className="leap-text-center leap-text-[25px] md:leap-text-[30px] lg:leap-text-[35px] leap-leading-[33px] leap-font-medium">
              Book Your Tour Now
            </span>
          )}
        </div>
        <div className="leap-flex-row leap-flex leap-gap-4 leap-justify-center">
          {showModal === "login" && !loggedIn && (
            <LoginEmail
              email={email}
              error={error}
              handleInputChange={handleInputChange}
              handleButtonClick={handleButtonClick}
              sendOTPState={sendOTPState}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Subscribe;
